import { ReactNode, useCallback } from 'react';

import { formatName } from '@libs/formatNames';
import { GameResultsBadge } from '@ui/components/GameResultBadge';
import { TableCell, TableRow } from '@ui/components/Table';

import { ParticipantGameMovementRow } from '@features/shared/api/typings';
import styles from '@features/tournament/ui/components/RoundMovement/RoundMovement.module.css';

type ParticipantsRoundMovementRowProps = {
  row: ParticipantGameMovementRow;
  hasTableNumbers: boolean;
  isChild: boolean;
  onGameClick?: (gameId: string) => void;
  renderQuickPeekShield?: (userId: string) => ReactNode;
};

export function ParticipantsRoundMovementRow({
  row,
  isChild,
  hasTableNumbers,
  onGameClick,
  renderQuickPeekShield,
}: ParticipantsRoundMovementRowProps) {
  const onRowClick = useCallback(() => {
    onGameClick && row.player1.game.gameId && onGameClick(row.player1.game.gameId);
  }, [row.player1.game.gameId, onGameClick]);

  return (
    <TableRow onClick={onRowClick} clickable hoverable>
      {isChild && hasTableNumbers && <TableCell />}

      {/* Для командных пока не отображаем номер стола, на бэке нету его */}
      {!isChild && <TableCell className={styles.no}>{row.boardNo}</TableCell>}

      <TableCell className={styles.playerName} leftGap={isChild}>
        <div className={styles.playerNameContainer}>
          {formatName(row.player1)}
          {(row.player1.firstName || row.player1.lastName) &&
            renderQuickPeekShield?.(row.player1.userId)}
        </div>
      </TableCell>
      <TableCell className={styles.results}>
        <GameResultsBadge
          className={styles.result}
          large
          gameId={row.player1.game.gameId}
          result={row.player1.game.resultType}
          cellResult={row.player1.game.cellResult}
          side={row.player1.game.side}
          score={row.player1.game.score}
          dotCentered
        />
        <GameResultsBadge
          className={styles.result}
          large
          gameId={row.player2.game.gameId}
          result={row.player2.game.resultType}
          cellResult={row.player2.game.cellResult}
          side={row.player2.game.side}
          score={row.player2.game.score}
          dotCentered
          reversed
        />
      </TableCell>
      <TableCell left className={styles.playerName}>
        <div className={styles.playerNameContainer}>
          {formatName(row.player2)}
          {(row.player2.firstName || row.player2.lastName) &&
            renderQuickPeekShield?.(row.player2.userId)}
        </div>
      </TableCell>
      {/*<TableCell className={styles.playerTitle}>{row.player2.title}</TableCell>*/}
    </TableRow>
  );
}
